/**
 * External dependencies
 */
import { createSelector } from 'reselect';
import { get, find, map, sortBy, reverse } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllCoupons } from 'state/coupons/selectors';
import { getAllAddons } from 'state/addons/selectors';

export const getCurrentTsPayId = (state) => get(state, ['currentTsPay', 'items']);

export const getCurrentTsPay = (state) => {

    return get(state, ['currentTsPay', 'items'], []);
};

export const requestingCurrentTsPay = (state) => get(state, ['currentTsPay', 'requesting'], false);

export const errorRequestingCurrentTsPay = (state) => get(state, ['currentTsPay', 'error'], false);

export const hasScheduledChanges = createSelector(
    getCurrentTsPay,
    (currentTsPay) => {
        return get(currentTsPay, ['has_scheduled_changes'], false);
    },
);
export const getCurrentTsPayPlanId = createSelector(
    getCurrentTsPay,
    (currentTsPay) => {
        return get(currentTsPay, ['plan_id'], null);
    },
);
